export const isEmpty = (obj) => {
  // Handle null or undefined objects gracefully
  if (obj == null) {
    return true;
  }

  // Check if object has no properties
  if (Object.keys(obj).length === 0) {
    return true;
  }

  // Check if all properties have empty, null or undefined values
  for (const key in obj) {
    if (
      Object.prototype.hasOwnProperty.call(obj, key) &&
      obj[key] !== '' &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      // Found a non-empty value
      return false;
    }
  }

  return true; // All properties are empty or null/undefined
};

const resolveEntityId = (value) => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;

  return (
    value._id ||
    value.id ||
    value.userRefId ||
    value.userId?._id ||
    value.userId?.id ||
    value.refId?._id ||
    value.refId?.id ||
    value.refId ||
    value.bahaiId ||
    value.details?._id ||
    value.details?.id
  );
};

const isGuestEntry = (item) => String(item?.type || '').toLowerCase() === 'guest';

export const transformParticipantsOrFacilitators = (array) => {
  return array
    ?.map((item) => {
      if (!item) return null;

      const id = resolveEntityId(item);
      if (id) {
        return { _id: id };
      }

      const referenceContact = resolveEntityId(item.referenceContact);
      if (isGuestEntry(item) || item.firstName || referenceContact) {
        return {
          firstName: item.firstName,
          lastName: item.lastName || '',
          referenceContact,
        };
      }

      return null;
    })
    .filter(Boolean);
};
// Transform hosts payload for updating event hosts
export const transformHosts = (array) => {
  return array
    ?.map((item) => {
      // Case 1: Nested `details` field (likely from eventDetails)
      const detailsId = resolveEntityId(item.details);
      if (detailsId) {
        return {
          refId: detailsId,
          type: item.type || 'User',
        };
      }

      // Case 2: Flat object with _id (likely from MemberAutocomplete)
      const id = resolveEntityId(item);
      if (id) {
        return {
          _id: id,
          type: item.type || 'Member',
        };
      }

      // Case 3: Fallback for guest user input
      const referenceContact = resolveEntityId(item.referenceContact);
      if (item.firstName && referenceContact) {
        return {
          firstName: item.firstName,
          lastName: item.lastName || '',
          referenceContact,
        };
      }

      // Otherwise skip invalid
      console.warn('⚠️ Skipping invalid host entry:', item);
      return null;
    })
    .filter(Boolean);
};

// Basic sanitization to help prevent simple injection attacks
export const sanitizeInput = (value) => {
  if (typeof value !== 'string') return value;
  return value
    .replace(/[;\'"\\]/g, '') // remove common injection characters
    .replace(/--/g, '');
};
